import React, { useState } from "react";
import { useForm } from "react-hook-form";
import authHeader from "services/auth-header";
import API from "services/axios";

function PaymentTermsAdd({ showAddPage, refreshFunc, lastSortId }) {
  /*   All States Below
   ********************************************* */
  const { register, handleSubmit } = useForm();
  const [formError, setFormError] = useState({});
  // redux

  /*   All Functions Below
   ********************************************* */
  const addPaymentTermsData = async (formData, e) => {
    setFormError({});
    e.preventDefault();
    if (formData.termName === "") {
      setFormError({
        termName: { type: "termName", message: "Term Name is required" },
      });
      return;
    }

    try {
      const { data } = await API.post(
        "/paymentTerms",
        { data: { ...formData, sortId: lastSortId + 1 } },
        { headers: authHeader() }
      );
      if (data.message.type === "success") {
        refreshFunc();
        showAddPage(false);
        return;
      }
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        {/*    ADD FORM START
         ********************************************* */}
        <div className="mb-13 ms-3">
          <h3>Add Payment Terms</h3>
        </div>
        <form
          className="ps-3 pe-3"
          onSubmit={handleSubmit(addPaymentTermsData)}
        >
          {/* ----------  Fields  ----------- */}
          <div className="mt-3 mb-3">
            <label htmlFor="termName" className="form-label">
              Terms Name
            </label>
            <input
              className="form-control"
              type="text"
              id="termName"
              placeholder="Enter term name"
              {...register("termName")}
            />
            {formError && formError.termName && (
              <p className="text-danger">{formError.termName.message}</p>
            )}
          </div>
          <div className="mb-3">
            <label htmlFor="noOfDays" className="form-label">
              No of Days
            </label>
            <input
              className="form-control"
              type="text"
              id="noOfDays"
              placeholder="Enter no of days"
              {...register("noOfDays")}
            />
          </div>

          <div className={`mt-4 mb-2 d-flex justify-content-end`}>
            <div>
              <button
                className="btn px-1 btn-secondary"
                type="button"
                onClick={() => {
                  showAddPage(false);
                }}
              >
                Cancel
              </button>
              <button className="btn btn-primary ms-1" type="submit">
                Add
              </button>
            </div>
          </div>
        </form>

        {/*    ADD FORM END
         ********************************************* */}
      </div>
    </div>
  );
}

export default PaymentTermsAdd;
